import Image from 'next/image';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import doctorPartner from './assets/novomedico.png';

import doctorPerson from '@/app/(main)/(pages)/_components/face-to-face-service-section/assets/persona-medica.png';
import { Button } from '@/components/ui/button/button.component';
import { Card } from '@/components/ui/card.component';
import { Link } from '@/components/ui/link/link.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { beOurPartnerUrl, partnerUrl } from '@/utils/consts/partner.consts';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

export const BecomePartnerCard = () => {
  return (
    <div
      className="flex flex-col-reverse gap-5 lg:flex-row lg:items-end"
      data-testid={DataTestIdEnum.FAQ_BECOME_PARTNER_CARD}
    >
      <Card className="flex flex-1 min-w-0 lg:w-1/2 flex-col gap-2">
        <Typography variant={TypographyVariant.BODY_STRONG} as="h2">
          Seja um parceiro Medprev!
        </Typography>
        <Typography variant={TypographyVariant.BODY_TEXT} as="p">
          Não há mensalidades ou taxas extras, o pagamento é fácil e seguro via Pix ou cartão de crédito em
          até 10x, e nosso time garante um atendimento acolhedor e personalizado em todas as etapas.
        </Typography>
        <Button
          asChild
          className="w-full"
          data-testid={DataTestIdEnum.FAQ_PROFESSIONAL_BE_OUR_PARTNER_BUTTON}
        >
          <Link
            prefetch={false}
            href={beOurPartnerUrl}
            target="_blank"
            data-analytics-event={AnalyticsEnum.CLICK_FAQ_PROFESSIONAL_BE_OUR_PARTNER}
          >
            Quero atender pela Medprev
          </Link>
        </Button>
        <hr className="my-3 border-gray-200" />
        <Typography variant={TypographyVariant.BODY_STRONG} as="h2">
          Já sou parceiro
        </Typography>
        <Button
          asChild
          variant="secondary"
          className="w-full"
          data-testid={DataTestIdEnum.FAQ_PROFESSIONAL_ENTER_SYSTEM_BUTTON}
        >
          <Link
            prefetch={false}
            href={partnerUrl}
            target="_blank"
            data-analytics-event={AnalyticsEnum.CLICK_FAQ_PROFESSIONAL_ACCESS_SYSTEM}
          >
            Entrar no sistema
          </Link>
        </Button>
      </Card>
      <div className="relative w-full aspect-[480/353] lg:w-1/2 lg:shrink-0">
        <div className="absolute left-[8.34%] right-0 top-[14.1%] bottom-0 rounded-[40px] bg-green-300" />
        <div className="absolute left-0 top-[11.19%] w-[60.93%] aspect-[2500/2681] overflow-hidden">
          <Image
            src={doctorPerson}
            alt="Profissional de saúde parceira Medprev"
            draggable={false}
            fill
            sizes="(min-width: 1024px) 300px, 60vw"
            className="object-cover object-top"
          />
        </div>
        <div className="absolute left-[42.64%] top-0 w-[57.36%] aspect-[2996/3840] overflow-hidden">
          <Image
            src={doctorPartner}
            alt="Profissional de saúde parceiro Medprev"
            draggable={false}
            fill
            sizes="(min-width: 1024px) 280px, 57vw"
            className="object-cover object-top"
          />
        </div>
      </div>
    </div>
  );
};
